module.exports = __webpack_public_path__ + "static/media/User_Robot_1.43ecaf19.svg";